// 🔧 demo_defaults.js
// ✅ Purpose: Default configuration model for the LGV Demo Engine
// ✅ Features:
// - Provides one standard demoConfig object used by all demo builders
// - Supports Phase 1 Core Package demo creation
// - Prepares Phase 2 add-on builders
// - Prepares future AI-generated demo content
// - Supports temporary customer demos and permanent live examples
// - Fully block-commented for clarity and future devs

export const DEFAULT_DEMO_CONFIG = {
  profile: "core_demo",
  industry: "car_show",
  intent: "internal_testing",
  package: "core",
  votingEngine: "points",
  size: "small",
  addOns: {
    sponsors: false,
    volunteers: false,
    vendors: false,
    tickets: false,
    auction: false,
    store: false,
    passport: false,
    social: false,
  },

  ai: {
    enabled: false,
  },

  expiration: {
    enabled: true,
    days: 14,
  },
};

export const buildDemoConfig = (overrides = {}) => {
  return {
    ...DEFAULT_DEMO_CONFIG,
    ...overrides,

    addOns: {
      ...DEFAULT_DEMO_CONFIG.addOns,
      ...(overrides.addOns || {}),
    },

    ai: {
      ...DEFAULT_DEMO_CONFIG.ai,
      ...(overrides.ai || {}),
    },

    expiration: {
      ...DEFAULT_DEMO_CONFIG.expiration,
      ...(overrides.expiration || {}),
    },
  };
};
